(function() {
  var bar = document.getElementById('sticky-atc-bar');
  var mainBtn = document.querySelector('.shopify-payment-button__button') ||
              document.querySelector('[data-testid="Checkout-button"]') ||
              document.querySelector('.product-form__submit');
  var minusBtn = document.getElementById('sticky-qty-minus');
  var plusBtn = document.getElementById('sticky-qty-plus');
  var qtyInput = document.getElementById('sticky-qty-input');
  var stickyBtn = document.getElementById('sticky-atc-btn');

  if (!bar) return;

  // Se não achar o botão principal, esconde a barra e para
  if (!mainBtn) {
    bar.style.display = 'none';
    return;
  }

  // Começa escondida
  bar.style.display = 'none';

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      bar.style.display = entry.isIntersecting ? 'none' : 'block';
    });
  }, { threshold: 0.1 });

  observer.observe(mainBtn);

  minusBtn.addEventListener('click', function() {
    var val = parseInt(qtyInput.value);
    if (val > 1) qtyInput.value = val - 1;
  });

  plusBtn.addEventListener('click', function() {
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  stickyBtn.addEventListener('click', function() {
    var mainQty = document.querySelector('[name="quantity"]');
    if (mainQty) mainQty.value = qtyInput.value;
    mainBtn.click();
  });
})();
